module.exports = __webpack_public_path__ + "static/media/guide8.e8b0d683.png";